<template>
<v-card>
	<v-card-title>
		<jm-table-filter
		:type="type"
		:entities="entities"
		v-on:filtered="setFiltered"
		></jm-table-filter>
	</v-card-title>

	<jm-table-view
	:entities="filteredEntities"
	:view="view"
	></jm-table-view>
</v-card>
</template>

<script>
import Vuex from 'vuex'
import { EntityCollection } from '@/assets/js/JMan/EntityCollection'
import { jman } from '@/services/jman'
import JmTableView from './widgets/TableView'
import JmTableFilter from './widgets/TableFilter'

export default {
	name: "JmEntities",

	provide () {

		return {
			entityType: this.$route.meta.entityType
		}

	},

	data () {

		return {
			running: false,
			filteredEntities: []
		};

	},

	watch: {

		type () {
			document.title = `JMan — ${this.name}`;
			this.filteredEntities = [];
			this.refresh();
		}

	},

	computed: {

		query () {
			return {
				type: this.type
			}
		},

		entities () {
			const entities = EntityCollection.filter(this.$store.state.jman.entities, this.query);
			return entities;
		},

		view () {
			return this.$store.state.tables.views[this.type];
		},

		type () {
			return this.$route.meta.entityType;
		},

		name () {
			return this.$route.name;
		},

		operationsRunning () {
			return this.running;
		},

		layout () {
			const layout = {};

			if (this.$vuetify.breakpoint.mdAndUp) {
				layout.row = true;
			} else {
				layout.column = true;
			}

			return layout;
		}
	},

	methods: {
		async refresh () {
			this.$store.dispatch('jman/startRefresh', this.query);

			this.running = true;
			await this.$store.dispatch('jman/readFromDB', this.query);
			this.running = false;
		},

		setFiltered (filteredEntities) {
			this.filteredEntities = filteredEntities;
		}
	},

	created () {
		this.refresh();
		this.filteredEntities = this.entities;
	},

	components: {
		JmTableView,
		JmTableFilter
	}
}
</script>

<style scoped>
@keyframes fade-in {
	0% {
		opacity: 0
	}
	50% {
		opacity: 0
	}
	100% {
		opacity: 1
	}
}

.delayed-display {
	animation: fade-in 2s;
}
</style>



// WEBPACK FOOTER //
// src/components/Entities.vue